const tabBlocks = document.querySelectorAll('.block-tab-standard');

const isNavigationActive = () =>
	document.querySelector(
		'.block-navigation.active, .block-navigation.search-active'
	);

const getActiveTabIndex = (tabButtons) =>
	Array.from(tabButtons).findIndex((tabButton) =>
		tabButton.closest('.wp-block-button')?.classList.contains('active')
	);

const activateTab = (tabButton) => {
	const tabButtonWrapper = tabButton?.classList?.contains('wp-block-button')
		? tabButton
		: tabButton?.closest('.wp-block-button');
	const tab = tabButtonWrapper?.closest('.block-tab-standard-tab');
	const tabBlock = tabButtonWrapper?.closest('.block-tab-standard');

	if (!tabBlock || !tab || !tabButtonWrapper) {
		return;
	}

	const activeTabs = tabBlock.querySelectorAll(
		'.block-tab-standard-tab > .wp-block-button.active'
	);

	if (activeTabs.length) {
		activeTabs.forEach((activeTab) => {
			if (activeTab !== tabButtonWrapper) {
				activeTab.classList.remove('active');
			}
		});
	}

	tabButtonWrapper.classList.add('active');

	const selectContainer = tabBlock.querySelector(
		'.block-tab-standard__mobile-select'
	);

	if (tab.hasAttribute('data-index') && selectContainer) {
		const activeIndex = tab.getAttribute('data-index');

		selectContainer.querySelectorAll('.tab-selector').forEach((span) => {
			span.classList.remove('active');
		});

		selectContainer
			.querySelector(`.tab-selector[data-index="${activeIndex}"]`)
			?.classList.add('active');
	}

	animateStats(tab);
};

// Initial setup and event listeners for manual tab selection
const toggleTab = (e) => {
	e.preventDefault();

	activateTab(e.currentTarget);
};

// Animate the stats using CSS classes
const animateStats = (tab) => {
	const statElements = tab.querySelectorAll('.block-stat');

	statElements.forEach((statElement) => {
		const firstStat = statElement.querySelector('p');

		if (firstStat) {
			// Add flip animation class
			firstStat.classList.add('flip-animation');
			// Remove the class after the animation ends (1 second)
			setTimeout(() => {
				firstStat.classList.remove('flip-animation');
			}, 1000);
		}
	});
};

if (tabBlocks.length) {
	tabBlocks.forEach((tabBlock) => {
		const tabs = tabBlock.querySelectorAll('.block-tab-standard-tab');

		if (tabs.length) {
			const selectContainer = tabBlock.querySelector(
				'.block-tab-standard__mobile-select'
			);

			if (!selectContainer) {
				return;
			}

			// Clear any existing children in the select container
			selectContainer.innerHTML = '';

			tabs.forEach((tab, index) => {
				const tabButton = tab.querySelector(
					'.block-tab-standard-tab > .wp-block-button'
				);

				if (tabButton) {
					// Create span element instead of option
					const span = document.createElement('span');
					span.classList.add('tab-selector');
					span.textContent = tabButton.textContent;
					span.setAttribute('data-index', index);

					// Append the span to the select container
					selectContainer.appendChild(span);

					// Add event listener to handle tab click
					span.addEventListener('click', () => {
						activateTab(tabButton);
					});

					tab.setAttribute('data-index', index);

					tabButton.classList.add('initialized');

					if (0 === index) {
						tabButton.classList.add('active');
						span.classList.add('active'); // Set the first span as active initially
					}
				}
			});
		}

		const tabButtons = tabBlock.querySelectorAll(
			'.block-tab-standard-tab > .wp-block-button .wp-block-button__link'
		);

		if (tabButtons.length) {
			tabButtons.forEach((tabButton) => {
				tabButton.addEventListener('click', toggleTab);
			});

			setInterval(() => {
				if (isNavigationActive()) {
					return;
				}

				const currentIndex = Math.max(getActiveTabIndex(tabButtons), 0);
				const nextIndex = (currentIndex + 1) % tabButtons.length;
				activateTab(tabButtons[nextIndex]);
			}, 4000);
		}
	});
}

document.addEventListener('DOMContentLoaded', () => {
	const statElements = document.querySelectorAll(
		'.block-tab-standard .block-stat'
	);

	statElements.forEach((statElement) => {
		const firstStat = statElement.querySelector('p');

		if (firstStat) {
			// Check if already wrapped to avoid duplication
			if (!firstStat.parentNode.classList.contains('stat-wrapper')) {
				// Create a wrapper div
				const wrapperDiv = document.createElement('div');
				wrapperDiv.classList.add('stat-wrapper');
				wrapperDiv.style.overflow = 'hidden'; // Apply overflow hidden

				// Wrap the <p> element
				firstStat.parentNode.insertBefore(wrapperDiv, firstStat);
				wrapperDiv.appendChild(firstStat);
			}
		}
	});
});
